export default function NotFound() {
  return (
    <div className="not-found-wrapper">
      <div className="error-status not-found-num">404</div>
      <div className="error-header">Ooops! Why you're here ?</div>
      <div className="error-text">
        We are very sorry for incovience. It looks like you're trying to access
        a page or url that either has been deleted or never existed
      </div>
    </div>
  );
}
